import { render, staticRenderFns } from "./SidebarNavList.vue?vue&type=template&id=796ba450&scoped=true"
import script from "./SidebarNavList.vue?vue&type=script&lang=js"
export * from "./SidebarNavList.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavList.vue?vue&type=style&index=0&id=796ba450&prod&lang=scss&scoped=true"
import style1 from "./SidebarNavList.vue?vue&type=style&index=1&id=796ba450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ba450",
  null
  
)

export default component.exports